import { vsLookupManagementServiceProviderName } from "./lookupManagement";
import { simpleLookupManagementConfig } from "../../../../records/lookup/utils/simpleLookupManagementConfig";

export const vsObjectName = "gamingContractPerformanceGuaranteeType";

const url = "api/contract/gamingContract/performanceGuaranteeType";

export const PerformanceGuaranteeConfig = simpleLookupManagementConfig({
  lookupEditPermission: "contractLookupModify",
  lookupManagementServiceProviderName: vsLookupManagementServiceProviderName,
  nameSingular: "Performance Guarantee",
  objectName: vsObjectName,
  url,
});
